import React from "react";
import { Fragment, useState, useEffect } from "react";

import { useTranslation } from "react-i18next/hooks";
import Img from "react-cool-img";

import Button from "../../Button/Button";
import Loader from "../../Loader/Loader";

import { useStore } from "../../../hook-store/store";
import { deleteUserFromGroupMembers } from "../../../util/group/group-invitation";

import { SOCKET_GROUP_URL } from "../../../App";

import SampleImage from '../../Image/person-icon-50.jpg';

import "../../../pages/GroupTalk/GroupTalk.css";
import "./GroupInvitation.css"

const GroupInviteAcceptUsers = (props) => {
  // console.log('grouplistItem.js props', props);

  const { group, usersData, userId, isLoading } = props;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { groupInvitationData } = store.groupStore;

  const [selectedUserId, setSelectedUserId] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);

  const deleteGroupUserHandler = async (groupRoomId, userId) => {
    try {
      setIsDataLoading(true);

      const resData = await deleteUserFromGroupMembers(
        SOCKET_GROUP_URL,
        localStorage.getItem("token"),
        groupRoomId,
        userId
      );

      if (resData) {
        const deletedAcceptUsers = groupInvitationData.inviteAcceptUsers.filter(
          (ele) => {
            return ele.userId !== userId;
          }
        );

        dispatch("SET_GROUPINVITATIONDATA", {
          ...groupInvitationData,
          inviteAcceptUsers: deletedAcceptUsers,
        });

        dispatch("SHOW_NOTIFICATION", {
          // status: 'pending',
          //   title: '',
          message: "delete success",
        });

        setTimeout(() => {
          dispatch("CLEAR_NOTIFICATION");
        }, 1000 * 5);

        setSelectedUserId("");
        setShowDeleteConfirm(false);
      }

      setIsDataLoading(false);
    } catch (err) {
      console.log(err);
      setIsDataLoading(false);
      throw err;
    }
  };

  let groupInviteAcceptUsersBody;

  if (groupInvitationData?.inviteAcceptUsers?.length > 0) {
    groupInviteAcceptUsersBody = (
      <div>
        <div className='groupInivitationTitle'>
          <strong>
           {t('groupTalk.text52', ' Group members (Invitation accepted users)')}
          </strong>
        </div>
        <ul className='groupInvitationList'>
          {groupInvitationData.inviteAcceptUsers.map((element) => {
            
            const lsNameDataList = localStorage.getItem('lsNameDataList');
            let acceptUserNameData 
            
            if (lsNameDataList) {
              acceptUserNameData = JSON.parse(lsNameDataList).find(ele => {
                return ele.userId === element.userId;
              });
            }

            // console.log('acceptUserNameData', acceptUserNameData)
            
            return (
              <li className='groupInvitationListItem'
                key={element.userId}
              >
                <div className='groupInvitationListItemRow'>
                  <span>
                    {acceptUserNameData && (
                      <div className='groupInvitationListItemNameRow'>
                        {acceptUserNameData.imageUrl && (
                          <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                            src={acceptUserNameData.imageUrl}
                          />
                        )}
                        {!acceptUserNameData.imageUrl && (
                          <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                            src={SampleImage}
                          />
                        )}
                        <span>
                          {acceptUserNameData.name}
                        </span>
                      </div>
                    )}
                    <div>
                      {element.email}
                    </div>
                    <div>
                      ({new Date(element.addAt).toLocaleDateString()})
                    </div>

                  </span>
                  <span>
                    <Button
                       mode="raised" design="" type="submit" size='smaller'
                      disabled={isDataLoading}
                      onClick={() => {
                        setSelectedUserId(element.userId);
                        setShowDeleteConfirm(true);
                      }}
                    >
                      {t('groupTalk.text49', 'Delete')}
                    </Button>
                  </span>
                </div>
                  {selectedUserId === element.userId && showDeleteConfirm && (
                    <div>
                      <div className='groupInvitationRow'>
                        {t('groupTalk.text53', 'Delete user from group members?')}
                      </div>
                      <div className='groupInvitationButtons'>
                        <Button
                          mode="" design="" type="submit" size='smaller'
                          disabled={isDataLoading}
                          onClick={() => {
                            setSelectedUserId("");
                            setShowDeleteConfirm(false);
                          }}
                        >
                          {t('groupTalk.text51', 'Cancel')}
                        </Button>
                        <Button
                          mode="raised" design="" type="submit" size='smaller'
                          disabled={isDataLoading}
                          onClick={() => {
                            deleteGroupUserHandler(
                              group.groupRoomId,
                              element.userId
                            );
                          }}
                        >
                          {t('groupTalk.text49', 'Delete')}
                        </Button>
                        {isDataLoading && <Loader />}
                      </div>
                    </div>
                  )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return (
    <Fragment>
      <div>{groupInviteAcceptUsersBody}</div>
    </Fragment>
  );
};

export default GroupInviteAcceptUsers;
